import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';

interface ISearch {
  className?: string;
  value: string;
  defaultValue?: string;
  onChange: Function;
  searchOptions: string[];
  onClick: Function;
  onFilterChange: Function;
  onEnter: Function;
  tagOptions?: { id: string; name: string }[];
  currentFilter?: string;
}

export function Search({
  value,
  onChange,
  defaultValue,
  className,
  searchOptions,
  onClick,
  onFilterChange,
  onEnter,
  tagOptions,
  currentFilter,
}: ISearch) {
  const isTagFilter = currentFilter === "tag";

  return (
    <div className={'flex justify-end items-center gap-2 ' + className}>
      <div className="border border-gray-300 rounded-lg flex overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200">
        <p className="px-3 py-2.5 bg-gray-50 text-gray-600 text-sm font-medium border-r border-gray-300">Filter by</p>
        <select
          className="focus:outline-none px-3 py-2.5 bg-white text-gray-700 cursor-pointer min-w-[140px]"
          name="search-options"
          id="search-optoins"
          onChange={(e) => {
            onFilterChange(e);
          }}
          defaultValue={defaultValue}
          value={currentFilter || defaultValue}
        >
          {searchOptions.map((e, i) => {
            return (
              <option key={i} value={e}>
                {e}
              </option>
            );
          })}
        </select>
      </div>
      <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200">
        {isTagFilter && tagOptions ? (
          <select
            className="focus:outline-none px-3 py-2.5 bg-white text-gray-700 min-w-[200px] cursor-pointer"
            value={value}
            onChange={(e) => {
              if (onChange) onChange(e);
              if (onEnter) onEnter();
            }}
          >
            <option value="">All Students</option>
            {tagOptions.map((tag) => (
              <option key={tag.id} value={tag.name}>
                {tag.name}
              </option>
            ))}
          </select>
        ) : (
          <>
            <input
              className="focus:outline-none focus:ring-2 focus:ring-cyan-500 px-3 py-2.5 bg-white text-gray-700 placeholder-gray-400 min-w-[200px]"
              type="text"
              placeholder="Search..."
              value={value}
              onChange={(e) => {
                if (onChange) onChange(e);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onEnter();
              }}
            />
            {!isTagFilter && (
              <button
                className="px-3 py-2.5 bg-cyan-500 hover:bg-cyan-600 text-white transition-colors duration-200 cursor-pointer"
                onClick={() => {
                  onClick();
                }}
              >
                <AiOutlineSearch className="text-xl" />
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
